export function accordion () {
    const accordionHeaders = document.querySelectorAll('.accordion-header');
        
    accordionHeaders.forEach(header => {
        header.addEventListener('click', function() {
            const accordionItem = this.closest('.accordion-item');
            const accordionBody = accordionItem.querySelector('.accordion-body');
            
            // Закрываем все другие аккордеоны
            document.querySelectorAll('.accordion-item').forEach(item => {
                if (item !== accordionItem) {
                    const otherBody = item.querySelector('.accordion-body');
                    const otherHeader = item.querySelector('.accordion-header');
                    if (otherBody) {
                        otherBody.style.maxHeight = null;
                        otherBody.classList.remove('show');
                    }
                    if (otherHeader) {
                        otherHeader.classList.remove('show');
                    }
                }
            });
            
            // Переключаем текущий аккордеон
            if (accordionBody.classList.contains('show')) {
                accordionBody.style.maxHeight = null;
                accordionBody.classList.remove('show');
                this.classList.remove('show');
            } else {
                accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";
                accordionBody.classList.add('show');
                this.classList.add('show');
            }
        });
    });
    
    const productCards = document.querySelectorAll('.product-accordion');
    
    productCards.forEach((el) => {
        el.addEventListener("mouseover", accordionHover, false);
        function accordionHover() {
            const findBtn = Array.from(el.children).find((btn) => btn.classList.contains('product-accordion__button'));
            findBtn.classList.add('active')
        }
    });

    productCards.forEach((el) => {
        el.addEventListener("mouseout", accordionUnHover, false);
        function accordionUnHover() {
            const findBtn = Array.from(el.children).find((btn) => btn.classList.contains('product-accordion__button'));
            findBtn.classList.remove('active')
        }
    });

    const orderReceipt = document.querySelectorAll('.order-receipt__title-block')

    orderReceipt.forEach((el) => {
        el.addEventListener('click', () => {
            const findInfo = Array.from(el.parentNode.children).find((el) => el.classList.contains('order-receipt__information'));
            el.classList.toggle('active');
            if (findInfo) {
                if (findInfo.classList.contains('show')) {
                    findInfo.style.maxHeight = null;
                    findInfo.classList.remove('show');
                } else {
                    findInfo.style.maxHeight = findInfo.scrollHeight * 2 + "px";
                    findInfo.classList.add('show');
                }
            };
        })
    })
    
}